<template>
  <v-sheet class="slide-group mx-auto pagination-breadcrumb">
    <v-slide-group multiple>
      <v-slide-item v-for="(indexHistory, index) of value" :key="index">
        <div class="breadcrumb-item d-flex align-center">
          <v-chip color="transparent" class="elevation-0 mx-0 px-0" @click="$emit('navigateBackward', index)">
            <v-icon medium v-if="indexHistory.icon" :class="index === value.length - 1 ? 'breadcrumb-current' : 'muted-accent--text'" class="mx-1">{{ indexHistory.icon }}</v-icon>&nbsp;
            <a class="breadcrumb-link">
              <span :class=" index === value.length - 1 ? 'breadcrumb-current font-weight-medium' : 'muted-accent--text'">
                {{ indexHistory.name }}
              </span>
            </a>
          </v-chip>
          <v-icon class="mx-1" v-if="index !== value.length - 1" :class="'muted-accent--text'">mdi-chevron-right</v-icon>
        </div>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
.pagination-breadcrumb .breadcrumb-link {
  color: inherit;
  text-decoration: none;
}

.pagination-breadcrumb .breadcrumb-current {
  color: var(--v-primary-base) !important;
}

.pagination-breadcrumb .v-icon.breadcrumb-current {
  color: var(--v-primary-base) !important;
}

.breadcrumb-item {
  display: inline-flex;
  align-items: center;
}
</style>
